import { createDecorator } from 'vue-class-component'

export const Meta = createDecorator((options, key) => {
  const metaInfo = 'metaInfo'
  options[metaInfo] = options.methods[key]
})

export const Hook = createDecorator((options, key) => {
  options[key] = options.methods[key]
  delete options.methods[key]
})
